import { Controller } from "stimulus";
import "select2";
import configureSelect2 from "../configureSelect2";

export default class extends Controller {
  static values = { element: String };

  append() {
    const template = document.getElementById(this.elementValue);
    const parent = template.parentElement;
    const newId = new Date().getTime();
    let newRecord = template.content.cloneNode(true);

    // We use the __new_object__ string as a placeholder for IDs and names in
    // the template. This sets those names and IDs to the current timestamp so
    // that we can submit more than one record per request.
    newRecord.querySelectorAll("input, select, textarea, label").forEach((el) => {
      for (let attribute of ["name", "id", "for"]) {
        if (el.getAttribute(attribute)) {
          el.setAttribute(attribute, el.getAttribute(attribute).replace(/__new_object__/g, newId));
        }
      }
    });

    parent.append(newRecord);

    configureSelect2(parent);

    const event = new CustomEvent("cortana:record_added", {
      bubbles: true,
    });
    parent.dispatchEvent(event);
  }
}
